/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CreateContactMemoRequestContactMemoFromJSON, CreateContactMemoRequestContactMemoToJSON } from './CreateContactMemoRequestContactMemo';
export function CreateCompanyMemoRequestFromJSON(json) {
    return CreateCompanyMemoRequestFromJSONTyped(json, false);
}
export function CreateCompanyMemoRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companyMemo: !exists(json, 'company_memo')
            ? undefined
            : CreateContactMemoRequestContactMemoFromJSON(json['company_memo'])
    };
}
export function CreateCompanyMemoRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_memo: CreateContactMemoRequestContactMemoToJSON(value.companyMemo)
    };
}
